export default {
  'bad-request': 'The server could not understand what you requested.',
  'auth-failed': 'Authentication failed.',
  'not-access': 'The user account in use does not have access privileges.',
  'not-found': 'The page you are looking for cannot be found.',
  'invalid-data': 'Failed to retrieve due to invalid data.',
  'get-failed': 'Failed to get data.',
  'server-error': 'A server error has occurred. Please try again later.',
}
